var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4249 19.4551C15.6231 19.6231 15.8781 19.6651 16.1062 19.5621C16.3331 19.4581 16.5006 19.2251 16.5512 18.9421C17.0849 15.9291 18.3812 8.30213 18.8674 5.56213C18.9049 5.35513 18.8424 5.14113 18.7074 5.00213C18.6344 4.93257 18.5533 4.88756 18.4691 4.86985C18.3848 4.85214 18.2992 4.8621 18.2174 4.89913C15.6406 6.04413 7.70056 9.61913 4.45556 11.0591C4.24993 11.1511 4.11618 11.3891 4.12306 11.6491C4.13056 11.9111 4.27681 12.1371 4.48743 12.2131C5.94306 12.7351 7.85306 13.4631 7.85306 13.4631C7.85306 13.4631 8.74556 16.6971 9.21118 18.3431C9.26931 18.5491 9.40431 18.7121 9.58181 18.7681C9.75868 18.8231 9.94806 18.7651 10.0806 18.6151L11.9843 16.4581C11.9843 16.4581 14.1799 18.3911 15.4256 19.4551H15.4249ZM8.65618 13.0531L9.68743 17.1391L9.91681 14.5521L16.1793 7.77413C16.2456 7.70213 16.2543 7.58113 16.1993 7.49613C16.1443 7.41113 16.0437 7.39213 15.9681 7.44913L8.65618 13.0531Z",
    fill: "#9C99AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.7b65a454.svg";
export { ForwardRef as ReactComponent };